import * as React from "react";

interface BuyerGuaranteeAppProps {}

export const BuyerGuaranteeApp: React.FC<BuyerGuaranteeAppProps> = ({
  children,
}) => {
  return <>{children}</>
}
